import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { pinia } from 'www/plugins'
import AppointmentCalendar from 'www/vue_components/common/AppointmentCalendar/AppointmentCalendar.vue'
import CalendarStub from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceCalendar/components/CalendarStub.vue'
import { getModuleDataInterface } from 'www/modules/Schedule/models'
import LpuNotWorkingLabel from 'www/vue_components/common/LpuNotWorkingLabel/LpuNotWorkingLabel.vue'
import useInvasiveServiceInfoStore from 'src/components/common/InvasiveServiceInfo/stores/useInvasiveServiceInfoStore'
import InvasiveServiceInfo from 'src/components/common/InvasiveServiceInfo/InvasiveServiceInfo.vue'

/**
 * @description
 * Модуль содержит методы, необходимые для рендера и уничтожения расписания.
 */
class ScheduleCalendar {
  #data = getModuleDataInterface()

  /**
   * @param {object} opts - данные интерфейса 'getModuleDataInterface', которые собраны со страницы
   */
  constructor(opts) { this.update(opts) }

  /**
   * @public
   * @description
   * Производит обновление приватного поля '#data'
   *
   * @param {object} opts -
   * @param {object} opts.data - данные интерфейса 'getModuleDataInterface', которые собраны со страницы
   */
  update({ data }) { this.#data = data }

  /**
   * @public
   * @description
   * Производит рендер расписания, основываясь на данных, которые передаются в 'constructor'.
   * В зависимости от устройства 'mobile' | 'desktop' вызывается нужный компонент
   *
   * @returns { Map } - возвращает список отрендеренных компонентов в формате { HTMLElement: VueComponent }
   */
  render() {
    const instances = new Map()

    let i = 0

    const mountElements = [...document.querySelectorAll('.vue-mount-lpu-not-working-label')]

    if (mountElements) {
      mountElements.forEach(mountElement => {
        new Vue({
          el: mountElement,
          components: {
            LpuNotWorkingLabel,
          },
        })
      })
    }

    this.#data.render.forEach((props, container) => {
      i++

      const isEmptySlotList = !Object.keys(props.slots).some(date => props.slots[date].length)

      if (isEmptySlotList && props.appointmentType === 'express') {
        container.innerHTML = '<div></div>'

        instances.set(container, new Vue({
          el: container.firstElementChild,
          name: `AppointmentCalendarRoot_${i}`,
          pinia,
          render: h => h(AppointmentCalendar, {
            props,
            lpuWorkingText: props.lpuWorkingText,
            lpuPhone: props.lpuPhone,
          }),
        }))

        return
      }

      if (isEmptySlotList) {
        container.innerHTML = '<div></div>'
        instances.set(container, new Vue({
          el: container.firstElementChild,
          name: `CalendarStubRoot_${i}`,
          render: h => h(CalendarStub),
        }))

        return
      }

      container.innerHTML = `<div class="${window.MOBILE_VERSION ? 'mx-n4' : 'mr-n6'}"><div class="schedule"></div></div>`

      const invasiveServiceInfoStore = useInvasiveServiceInfoStore(pinia)

      if (
        !invasiveServiceInfoStore.isCreatedComponent
        && (
          props.serviceData?.allowTreatmentReferral
          || (props.serviceData?.requiresPrimaryConsultation && props.serviceData?.hasPrimaryConsultationDoctors)
        )
      ) {
        const mountEl = document.createElement('div')

        container.append(mountEl)

        new Vue({
          vuetify,
          el: mountEl,
          pinia,
          name: 'InvasiveServiceInfoRoot',
          render: h => h(InvasiveServiceInfo),
        })
      }

      const additionalProps = {
        paddingLeft: window.MOBILE_VERSION ? 16 : 0,
        fog: window.MOBILE_VERSION ? false : 'left',
      }

      instances.set(container, new Vue({
        el: container.querySelector('.schedule'),
        name: `AppointmentCalendarRoot_${i}`,
        pinia,
        render: h => h(AppointmentCalendar, {
          props: {
            ...props,
            ...additionalProps,
            lpuWorkingText: props.lpuWorkingText,
            lpuPhone: props.lpuPhone,
          },
        }),
      }))
    })

    return instances
  }

  /**
   * @public
   * @description
   * Производит частичный дестрой компонентов(только того списка, который передан)
   *
   * @param {object} opts -
   * @param { Map } opts.instances - список компонентов, у которых необходимо вызвать '$destroy' в формате, возвращаемым методом 'render'
   */
  destroyMap({ instances = new Map() } = {}) {
    instances.forEach((instance, node) => {
      if (this.#data.instances.has(node)) {
        this.#data.instances.get(node).$destroy()
      }
    })
  }

  /**
   * @public
   * @description
   * Производит полный дестрой компонентов(основываясь на данных, которые переданы в 'constructor')
   */
  destroyAll() {
    try {
      this.#data.instances.forEach(instance => instance.$destroy())
      this.#data.instances.clear()
    } catch { /* Empty */ }
  }
}

export default ScheduleCalendar
